import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import useTranslations from '../../../i18n/useTranslations'
import AddressEditionUI from '../../../ui/modules/AddressEdition'
import EmptyState from '../../../ui/components/EmptyState'
import {
  useEditAddressMutation,
  formatEditAddressToBodyData,
} from '../../../services/addressBook'

import { getCompleteAddressFromData } from '../../business'

import useAddressEditionForm from './useAddressEditionForm'

const AddressEdition = ({
  initialData,
  currentStep,
  onGoBack,
  onUpdateAddress,
  countries,
}) => {
  const t = useTranslations()
  const intl = useIntl()

  const [serverErrors, setServerErrors] = useState([])
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)

  const editAddressMutation = useEditAddressMutation(
    setServerErrors,
    () => setShowSuccessMsg(true),
    onUpdateAddress,
  )
  
  const handleSubmitEdition = formValues => {
    const addressData = { data: formValues, rawData: initialData.rawData }
    editAddressMutation.mutate({
      addressData: formatEditAddressToBodyData(addressData),
    })
  }

  const initialValues = getCompleteAddressFromData(initialData.data ?? initialData, intl, t)

  const {
    formik,
    enhancedFormik,
    handleChangeAutocompleteAddress,
    handleTouchedAutocompleteAddress,
  } = useAddressEditionForm(initialValues, serverErrors, handleSubmitEdition, currentStep)

  const handleClickGoBack = () => {
    onGoBack()
    setShowSuccessMsg(false)
  }

  return (
    <>
      {!showSuccessMsg ? (
          <AddressEditionUI
            values={formik.values}
            touched={formik.touched}
            onChange={enhancedFormik.handleChange}
            onSubmit={enhancedFormik.handleSubmit}
            onBlur={formik.handleBlur}
            onChangeAutocompleteAddress={handleChangeAutocompleteAddress}
            onTouchAutocompleteAddress={handleTouchedAutocompleteAddress}
            fieldErrors={enhancedFormik.fieldErrors}
            formErrors={enhancedFormik.formErrors}
            currentStep={currentStep}
            onCancel={onGoBack}
            isSubmitting={editAddressMutation.isLoading}
            countries={countries}
          />
      ) : (
        <EmptyState
          title={t('shipping-send-form:address-edition:success')}
          buttonText={t('shipping-send-form:address-edition:return')}
          onClick={handleClickGoBack}
        />
      )}
    </>
  )
}

AddressEdition.propTypes = {
  initialData: PropTypes.object,
  currentStep: PropTypes.string,
  onGoBack: PropTypes.func,
  onUpdateAddress: PropTypes.func,
  countries: PropTypes.object,
}

export default AddressEdition
